import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const HomeSettingComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>기본 설정</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>기본 설정 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default HomeSettingComponent;
